import { useMemo } from "react";
import { useReadContracts } from "wagmi";
import useDappConfig from "./useDappConfig";
import { formatUnits } from "viem";

const useCryptaniumVaultExchangeRate = () => {
    const { cryptaniumVaultConfig } = useDappConfig();
    const exchangeRateContracts = useMemo(() => {
        const contracts = [];
        const vaultConfig = cryptaniumVaultConfig?.interactionPool;

        if (!vaultConfig) {
            return [];
        }

        //Deposit
        contracts.push({
            ...vaultConfig,
            functionName: "convertToShares",
            args: [1000000],
            chainId: cryptaniumVaultConfig.chain.id,
        });

        //Withdraw
        contracts.push({
            ...vaultConfig,
            functionName: "convertToAssets",
            args: [1000000],
            chainId: cryptaniumVaultConfig.chain.id,
        });

        return contracts;
    }, [cryptaniumVaultConfig]);

    const { data, isLoading } = useReadContracts({
        contracts: exchangeRateContracts,
        query: {
            refetchInterval: 90_000,
        },
    });

    /*
      toShare -> Deposit (fromERC20)
      toAsset -> Withdraw (toERC20)
   */
    const exchangeData = useMemo(() => {
        if (data) {
            return {
                fromERC20: data[0]?.result && formatUnits(data[0]?.result as bigint, 6),
                toERC20: data[1]?.result && formatUnits(data[1]?.result as bigint, 6),
                isLoading,
            };
        }
        return { fromERC20: 0, toERC20: 0, isLoading };
    }, [data, isLoading]);

    return exchangeData;
};

export default useCryptaniumVaultExchangeRate;